import type { SVGProps } from "react";
export default function SvgMemoDraftingApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 162 194"
			{...props}
		>
			<path
				fill="#FAFF00"
				d="M88.754 14.138H77.36C77.361 10.75 74.601 8 71.2 8s-6.162 2.75-6.162 6.138H53.644a3.677 3.677 0 0 0-3.684 3.67v7.458c0 2.027 1.65 3.67 3.684 3.67h35.11a3.677 3.677 0 0 0 3.684-3.67v-7.458c0-2.027-1.65-3.67-3.684-3.67"
			/>
			<foreignObject width={142.438} height={192.663} x={0} y={1.33691}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1091_1111_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1091_1111)">
				<path
					fill="url(#paint0_linear_1091_1111)"
					fillOpacity={0.6}
					d="M97.122 19.337H45.317c-2.937 0-5.317 2.37-5.317 5.296v74.072c0 2.924 2.38 5.295 5.317 5.295h51.805c2.936 0 5.316-2.371 5.316-5.295V24.633c0-2.925-2.38-5.296-5.316-5.296"
				/>
				<path
					stroke="url(#paint1_linear_1091_1111)"
					d="M45.316 19.837h51.806c2.662 0 4.816 2.15 4.816 4.796v74.071c0 2.647-2.154 4.796-4.816 4.796H45.316c-2.662 0-4.816-2.149-4.816-4.796V24.633c0-2.647 2.154-4.796 4.816-4.796Z"
				/>
			</g>
			<foreignObject width={126.068} height={153.894} x={35.4243} y={34.04}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1091_1111_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1091_1111)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="m84.758 95.015-7.29 2.814c-1.214.47-2.408-.723-1.94-1.932l2.825-7.262a9 9 0 0 1 2.026-3.1l32.749-32.62a3.003 3.003 0 0 1 4.239 0l3.249 3.237a2.98 2.98 0 0 1 0 4.222l-32.749 32.62a9 9 0 0 1-3.112 2.019z"
				/>
				<path
					stroke="url(#paint2_linear_1091_1111)"
					strokeOpacity={0.5}
					d="M113.481 53.27a2.505 2.505 0 0 1 3.344-.171l.189.17 3.249 3.237a2.48 2.48 0 0 1 0 3.514L87.514 92.64a8.5 8.5 0 0 1-2.938 1.906l-.72.277.004.003-6.571 2.536h-.001c-.812.314-1.603-.483-1.293-1.284l2.824-7.262a8.5 8.5 0 0 1 1.913-2.926z"
				/>
			</g>
			<path
				fill="#F5FCFF"
				d="M89.067 46.052H53.332a2.253 2.253 0 0 1-2.258-2.25 2.253 2.253 0 0 1 2.258-2.248h35.735a2.253 2.253 0 0 1 2.258 2.249 2.253 2.253 0 0 1-2.258 2.249"
			/>
			<path
				fill="#F5FCFF"
				d="M89.067 60.077H53.332a2.253 2.253 0 0 1-2.258-2.249 2.253 2.253 0 0 1 2.258-2.249h35.735a2.253 2.253 0 0 1 2.258 2.25 2.253 2.253 0 0 1-2.258 2.248"
			/>
			<path
				fill="#F5FCFF"
				d="M72.079 74.104H53.332a2.253 2.253 0 0 1-2.258-2.249 2.253 2.253 0 0 1 2.258-2.249H72.08a2.253 2.253 0 0 1 2.258 2.25 2.253 2.253 0 0 1-2.258 2.248"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1091_1111"
					x1={71.3784}
					x2={71.3784}
					y1={19.3369}
					y2={104}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1091_1111"
					x1={71.2191}
					x2={34.0767}
					y1={20.2641}
					y2={81.1377}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1091_1111"
					x1={98.4586}
					x2={98.4586}
					y1={52.04}
					y2={97.9334}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1091_1111_clip_path" transform="translate(0 -1.337)">
					<path d="M97.122 19.337H45.317c-2.937 0-5.317 2.37-5.317 5.296v74.072c0 2.924 2.38 5.295 5.317 5.295h51.805c2.936 0 5.316-2.371 5.316-5.295V24.633c0-2.925-2.38-5.296-5.316-5.296" />
				</clipPath>
				<clipPath id="bgblur_1_1091_1111_clip_path" transform="translate(-35.424 -34.04)">
					<path d="m84.758 95.015-7.29 2.814c-1.214.47-2.408-.723-1.94-1.932l2.825-7.262a9 9 0 0 1 2.026-3.1l32.749-32.62a3.003 3.003 0 0 1 4.239 0l3.249 3.237a2.98 2.98 0 0 1 0 4.222l-32.749 32.62a9 9 0 0 1-3.112 2.019z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1091_1111"
					width={142.438}
					height={192.663}
					x={0}
					y={1.33691}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419977 0 0 0 0 0.656982 0 0 0 0 0.716233 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1111" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1111"
						result="effect2_dropShadow_1091_1111"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1111"
						result="effect3_dropShadow_1091_1111"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1111"
						result="effect4_dropShadow_1091_1111"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1111" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1111" />
				</filter>
				<filter
					id="filter1_ddddi_1091_1111"
					width={126.068}
					height={153.894}
					x={35.4243}
					y={34.04}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1111" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.027451 0 0 0 0 0.109804 0 0 0 0 0.152941 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1111"
						result="effect2_dropShadow_1091_1111"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1111"
						result="effect3_dropShadow_1091_1111"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1111"
						result="effect4_dropShadow_1091_1111"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1111" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1111" />
				</filter>
			</defs>
		</svg>
	);
}
